import React from 'react'
import {
  Container,
  Row,
  Col,
  Alert,
} from 'reactstrap'
import TopNavigation from '../../TopNavigation'
import withAppconfig from '../../AppContext'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import EventTicketCard from '../../components/Shop/EventTicketCard'
import ProductCard from '../../components/Shop/ProductCard'

const mapStateToProps = (state, props) => {
  const {
    firebase
  } = state
  if(!firebase.ordered.shopeventtickets) return { eventtickets: null }
  const eventtickets = firebase.ordered.shopeventtickets.map((m) => {
    const poster = m.value.image
    return { id: m.key, ...m.value, poster: poster }
  })
  return {
    eventtickets,
  }
}

const withProducts = compose(
  connect((state) => ({ auth: state.firebase.auth })),
  firebaseConnect((props) => [
    {
      path: 'shop/' + props.appconfig.accountkey + '/eventtickets',
      // queryParams: ['orderByChild=startDate'],
      storeAs: 'shopeventtickets',
    },
  ]),
  connect(mapStateToProps)
)

function MembershipsScreen({ appconfig, eventtickets, auth }) {
  const { t } = useTranslation()
  const isAuth = auth.isLoaded && !auth.isEmpty
  return (
    <div className='full-page-background'>
      <TopNavigation />
      <Container className='front' style={{ paddingTop: 10 }}>
        {!isAuth ? (<Alert color='warning'>{t('login_to_buy_eventtickets')}</Alert>) : null}
        <Typography variant='h6' style={{ paddingBottom: 20 }}>
          {t('eventtickets')}
        </Typography>
        {eventtickets && eventtickets.length > 0 ? (
          <Row>
            {eventtickets.map((m) => (
              <Col key={m.id} xs={12} sm={12}>
                <EventTicketCard product={m} collection={'eventtickets'} isAuthRequired={true} isAuth={isAuth} />
              </Col>
            ))}
          </Row>
        ) : (
          null
        )}
      </Container>
    </div>
  )
}

export default withAppconfig(withProducts(MembershipsScreen))
